
import React, { useState, useRef, useEffect } from 'react';
import {
  Box, Button, Grid, Typography, TextField, MenuItem, Paper,
  Tabs, Tab, Chip
} from '@mui/material';
import {
  Settings, WarningAmber, SupportAgent, School,
  UploadFile, Mic
} from '@mui/icons-material';
import RecordRTC from 'recordrtc';

import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import MicIcon from '@mui/icons-material/Mic';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import IconButton from '@mui/material/IconButton';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import GroupIcon from '@mui/icons-material/Group';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import InventoryIcon from '@mui/icons-material/Inventory';
import BarChartIcon from '@mui/icons-material/BarChart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import FactoryIcon from '@mui/icons-material/Factory';
import BuildIcon from '@mui/icons-material/Build';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'; // o el ícono que uses

import TicketProcessingStatus from './ticketProcessingStatus';
import { createSupport, uploadimgticket, updateSupport } from '../../../../services/supports/supports';
import { showAlert } from '../../../../main_components/alerts/alert_response';
import NOTIFICATION_SYSTEM from '../../../../main_components/alerts/notification_sistem';
import {
  modulos,
  activos_categories,
  bancos_categories,
  colaboradores_categories,
  finanzas_categories,
  inventarios_categories,
  reportes_categories,
  compras_categories,
  facturas_categories,
  snegocios_categories,
  unilever_categories,
  soporte,
  android_categories
} from './hooks/helpers';
type CategoryOption = { value: string; label: string };
type TicketFormProps = {
  handleClose?: () => void;
  onTicketUpdate: (updated: any) => void;

};

const getFileIcon = (file: File) => {
  if (file.type.startsWith('image/')) return <ImageIcon sx={{ color: '#8B5CF6' }} />;
  if (file.type === 'application/pdf') return <PictureAsPdfIcon sx={{ color: '#EF4444' }} />;
  if (file.type.startsWith('audio/')) return <MicIcon sx={{ color: '#10B981' }} />;
  return <InsertDriveFileIcon sx={{ color: '#6B7280' }} />;
};


const moduloIcons: Record<string, JSX.Element> = {
  'ACTIVOS': <BusinessIcon />,
  'BANCOS': <AccountBalanceIcon />,
  'COLABORADORES': <GroupIcon />,
  'FINANZAS': <MonetizationOnIcon />,
  'INVENTARIOS': <InventoryIcon />,
  'REPORTES': <BarChartIcon />,
  'COMPRAS': <ShoppingCartIcon />,
  'FACTURAS': <ReceiptIcon />,
  'SOCIO DE NEGOCIOS': <PeopleAltIcon />,
  'OPERACIONES CON UNILEVER': <FactoryIcon />,
  'SOPORTE': <BuildIcon />,
  'ANDROID MÓVIL': <PhoneIphoneIcon />,
};


const TicketForm = ({ handleClose, onTicketUpdate }: TicketFormProps) => {
  const [activeTab, setActiveTab] = useState(0);

  const [reportType, setReportType] = useState('');
  const [module, setModule] = useState('');
  const [category, setCategory] = useState('');
  const [severity, setSeverity] = useState('Baja');
  const [subject, setSubject] = useState('');
  const [question, setQuestion] = useState('');
  const [description, setDescription] = useState('');
  const [files, setFiles] = useState<File[]>([]);
  const [isRecording, setIsRecording] = useState(false);
  const [recorder, setRecorder] = useState<any>(null);
  const [stream, setStream] = useState<MediaStream | null>(null);
  const [previewFile, setPreviewFile] = useState<{ url: string; type: string } | null>(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const maxDurationRef = useRef<NodeJS.Timeout | null>(null); // Agrega esto en los hooks arriba
  const [availableCategories, setAvailableCategories] = useState<CategoryOption[]>([]);
  const [modoBusquedaModulo, setModoBusquedaModulo] = useState(false);
  const [searchModule, setSearchModule] = useState('');
  const [searchCategory, setSearchCategory] = useState('');
  const notificationSystemRef = useRef<any>(null);


  const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const [hasBeenReported, setHasBeenReported] = useState<boolean | null>(false);


  // const reportTypes = [
  //   { label: 'Sugerencias de funcionalidades', description: 'Propón ideas para nuevas funciones o mejoras en el sistema.', icon: <Settings color="primary" />, value: 'sugerencias' },
  //   { label: 'Error en Sistema', description: 'Informa fallos, errores técnicos o comportamientos inesperados.', icon: <WarningAmber sx={{ color: '#F9B233' }} />, value: 'error' },
  //   { label: 'Atención a clientes', description: 'Solicita ayuda o soporte sobre el uso adecuado del sistema.', icon: <SupportAgent color="primary" />, value: 'atencion' },
  //   { label: 'Capacitación', description: 'Solicita sesiones o materiales para capacitarte en el sistema.', icon: <School color="primary" />, value: 'capacitacion' }
  // ];

  const reportTypes = [
    {
      label: 'Sugerencias de funcionalidades',
      description: 'Propón ideas para nuevas funciones o mejoras en el sistema.',
      icon: <Settings color="primary" />,
      value: 'Sugerencia',
    },
    {
      label: 'Error en Sistema',
      description: 'Informa fallos, errores técnicos o comportamientos inesperados.',
      icon: <WarningAmber sx={{ color: '#F9B233' }} />,
      value: 'Error de sistema',
    },
    {
      label: 'Atención a clientes',
      description: 'Solicita ayuda o soporte sobre el uso del sistema.',
      icon: <SupportAgent color="primary" />,
      value: 'Atención a Clientes',
    },
    {
      label: 'Capacitación',
      description: 'Solicita sesiones o materiales para capacitarte en el sistema.',
      icon: <School color="primary" />,
      value: 'Capacitación',
    }
  ];


  const questionsUser = [
    {
      label: 'No',
      description: 'No, es la primera vez que lo reporto.',
      icon: <Settings color="primary" />,
      value: false,
    },
    {
      label: 'Si',
      description: 'Sí, ya lo reporté antes!!!.',
      icon: <WarningAmber sx={{ color: '#F9B233' }} />,
      value: true,
    },

  ];


  const severities = [
    { label: 'Baja', color: '#2EE6A8' },
    { label: 'Media', color: '#F9B233' },
    { label: 'Alta', color: '#F50545' }
  ];

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files;
    if (!selectedFiles) return;

    const maxSizeMB = 4.9;

    const validFiles = Array.from(selectedFiles).map((file) => {
      const fileSizeMB = file.size / (1024 * 1024); // convertir a MB

      if (fileSizeMB > maxSizeMB) {
        showAlert({
          msj: `El archivo "${file.name}" supera el tamaño máximo de ${maxSizeMB} MB.`,
          status: false,
          notificationSystemRef: notificationSystemRef,
        });
        return null;
      }

      const renamed = formatFileNameByType(file);
      if (!renamed) {
        showAlert({
          msj: `Formato no permitido: ${file.name}`,
          status: false,
          notificationSystemRef: notificationSystemRef,
        });
        return null;
      }

      return new File([file], renamed, { type: file.type });
    }).filter(Boolean) as File[];

    setFiles((prev) => [...prev, ...validFiles]);
  };




  useEffect(() => {
    const selected = modulos.find((m) => m.value === module);
    let categories: CategoryOption[] = [];
    switch (selected?.value) {
      case 'ACTIVOS': categories = activos_categories; break;
      case 'BANCOS': categories = bancos_categories; break;
      case 'COLABORADORES': categories = colaboradores_categories; break;
      case 'FINANZAS': categories = finanzas_categories; break;
      case 'INVENTARIOS': categories = inventarios_categories; break;
      case 'REPORTES': categories = reportes_categories; break;
      case 'COMPRAS': categories = compras_categories; break;
      case 'FACTURAS': categories = facturas_categories; break;
      case 'SOCIO DE NEGOCIOS': categories = snegocios_categories; break;
      case 'OPERACIONES CON UNILEVER': categories = unilever_categories; break;
      case 'SOPORTE': categories = soporte; break;
      case 'ANDROID MÓVIL': categories = android_categories; break;
      default: categories = [];
    }

    setAvailableCategories(categories);
    setCategory(categories[0]?.value || '');
  }, [module]);


  const formatFileNameByType = (file: File): string | null => {
    const ext = file.name.split('.').pop()?.toLowerCase() || '';
    const now = new Date();
    const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now.getTime()}`;

    if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt', 'xml'].includes(ext)) {
      return `DOC__${timestamp}.${ext}`;
    } else if (['jpg', 'jpeg', 'png'].includes(ext)) {
      return `IMG__${timestamp}.${ext}`;
    } else if (['wav', 'mp3', 'm4a', 'ogg'].includes(ext)) {
      return `AUDIO__${timestamp}.${ext}`;
    } else {
      return null;
    }
  };


  const handleRemoveFile = (index: number) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAudioRecording = async () => {
    if (!isRecording) {
      try {
        const micStream = await navigator.mediaDevices.getUserMedia({ audio: true });

        const newRecorder = new RecordRTC(micStream, {
          type: 'audio',
          mimeType: 'audio/wav',
          recorderType: RecordRTC.StereoAudioRecorder,
          desiredSampRate: 16000,
          numberOfAudioChannels: 1
        });

        newRecorder.startRecording();
        setRecorder(newRecorder);
        setStream(micStream);
        setIsRecording(true);
        setRecordingTime(0);

        // ⏱️ Mostrar tiempo visual
        timerRef.current = setInterval(() => {
          setRecordingTime((prev) => prev + 1);
        }, 1000);

        // ⛔ Auto stop a los 150 segundos (aprox. 4.8 MB .wav)
        maxDurationRef.current = setTimeout(() => {
          if (newRecorder) {
            newRecorder.stopRecording(() => {
              const audioBlob = newRecorder.getBlob();
              const tempFile = new File([audioBlob], "temp.wav", { type: 'audio/wav' });
              const renamedName = formatFileNameByType(tempFile);
              const audioFile = new File([audioBlob], renamedName || 'audio.wav', { type: 'audio/wav' });

              setFiles((prev) => [...prev, audioFile]);

              micStream.getTracks().forEach((track) => track.stop());
              setStream(null);
              setRecorder(null);
              setIsRecording(false);
              clearInterval(timerRef.current!);
              clearTimeout(maxDurationRef.current!);

              // alert("La grabación se detuvo automáticamente al alcanzar el tamaño máximo permitido (~2m 29s).");
              showAlert({
                msj: "La grabación se detuvo automáticamente al alcanzar el tamaño máximo permitido (~2m 29s).",
                status: false,
                notificationSystemRef: notificationSystemRef,
              });
            });
          }
        }, 150000); // 150 segundos
      } catch (err) {
        console.error("Error al iniciar grabación:", err);
        showAlert({
          msj: "No se pudo acceder al micrófono.",
          status: false,
          notificationSystemRef: notificationSystemRef,
        });
      }
    } else {
      // Detener manualmente
      if (recorder) {
        recorder.stopRecording(() => {
          const audioBlob = recorder.getBlob();
          const tempFile = new File([audioBlob], "temp.wav", { type: 'audio/wav' });
          const renamedName = formatFileNameByType(tempFile);
          const audioFile = new File([audioBlob], renamedName || 'audio.wav', { type: 'audio/wav' });

          setFiles((prev) => [...prev, audioFile]);

          stream?.getTracks().forEach((track) => track.stop());
          setStream(null);
          setRecorder(null);
          setIsRecording(false);
          clearInterval(timerRef.current!);
          clearTimeout(maxDurationRef.current!);
        });
      }
    }
  };


  const getModuloSubtitle = (modulo: string) => {
    const subtitles: Record<string, string> = {
      'ACTIVOS': 'Gestión de activos fijos',
      'BANCOS': 'Operaciones bancarias',
      'COLABORADORES': 'Gestión de personal',
      'FINANZAS': 'Contabilidad y finanzas',
      'INVENTARIOS': 'Control de inventario',
      'REPORTES': 'Informes y análisis',
      'COMPRAS': 'Proceso de compras',
      'FACTURAS': 'Facturación',
      'SOCIO DE NEGOCIOS': 'Gestión de socios',
      'OPERACIONES CON UNILEVER': 'Órdenes Unilever',
      'SOPORTE': 'Atención y soporte técnico',
      'ANDROID MÓVIL': 'Aplicación móvil',
    };
    return subtitles[modulo] || '';
  };




  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result;
        if (typeof result === 'string') {
          const base64String = result.split(',')[1];
          if (base64String !== undefined) {
            resolve(base64String);
          } else {
            reject(new Error("No se pudo extraer la parte base64 del archivo."));
          }
        } else {
          reject(new Error("Error: el resultado del archivo no es una cadena."));
        }
      };

      reader.onerror = () => {
        reject(new Error("Error al leer el archivo."));
      };

      reader.readAsDataURL(file);
    });
  };


  const handleUploadPendingTicketFiles = async (ticketId: string, fileList: File[]) => {
    const uploadedFiles: any[] = [];
    const pendingTicketFiles = fileList.map(file => ({
      file,
      renamedName: file.name,
    }));

    for (const fileObj of pendingTicketFiles) {
      try {
        const base64 = await fileToBase64(fileObj.file);
        const payload = {
          file_name: fileObj.renamedName,
          file_b64: base64,
        };

        const res = await uploadimgticket(ticketId, payload);
        uploadedFiles.push({
          file_name: res.data.file_name,
          file: base64,
        });
      } catch (err) {
        console.error(`Error subiendo archivo ${fileObj.renamedName}`, err);
      }
    }

    // Asociar archivos al ticket
    const allFileNames = uploadedFiles.map(f => f.file_name);
    if (allFileNames.length > 0) {
      try {
        await updateSupport(ticketId, { images: allFileNames });
        console.log("✅ Ticket actualizado con archivos:", allFileNames);
      } catch (error) {
        console.error("❌ Error actualizando ticket con archivos:", error);
      }
    }

    return allFileNames;
  };

  const handleCreateTicket = async () => {
    const hasAudio = files.some((file) => file.type.startsWith('audio/'));
    const hasFiles = files.length > 0;

    if (!subject.trim()) {
      showAlert({
        msj: "El asunto no puede estar vacío.",
        status: false,
        notificationSystemRef: notificationSystemRef,
      });
      return;
    }



    let finalDescription = description.trim();

    if (!hasAudio && finalDescription === '') {
      showAlert({
        msj: "Por favor describe tu caso o graba un audio.",
        status: false,
        notificationSystemRef: notificationSystemRef,
      });
      return;
    }

    if (hasAudio && finalDescription === '') {
      finalDescription = "Hay un audio";
    }

    setIsProcessing(true); // Muestra el panel
    setProgress(10);       // Simula el inicio

    const ticketObject = {
      subject: subject.trim(),
      mail_support: "",
      status: "OPEN",
      submodule: category,
      module: module,
      description: finalDescription,
      severity: severity,
      type: reportType,
      activate_alert: !hasFiles,
      recurrent_incidence: hasBeenReported,
      note_latest_report: question.trim() || "No hay pregunta",
    };

    try {
      const res = await createSupport(ticketObject);
      const ticketId = res.data.ticket;
      console.log("🎫 Ticket creado:", ticketId);
      const now = new Date();
      const formatDate = (date: Date) =>
        `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;



      let ticketData = {
        subject: subject.trim(),
        ticket: ticketId,
        company_id: res.data.company_id || "1",
        company_rfc: res.data.company_rfc, // puedes reemplazarlo si es dinámico
        last_update: formatDate(now),
        user_email: sessionStorage.getItem("user_email") || "correo@pendiente.com",
        status: "OPEN",
        close_date: formatDate(now), // puedes ajustarlo según lógica real
        user_roles: "No disponible",
        folio: res.data.folio, // puedes generar uno si es necesario
        times_reopened: 0,
        key_jira: "",
        date: formatDate(now),
        submodule: category,
        edited: false,
        images: [] as string[], // Aquí puedes agregar los nombres de archivos si es necesario
        description: finalDescription,
        module: module,
        user_name: res.data.user_name,
        severity: severity,
        type: reportType,
        recurrent_incidence: hasBeenReported,
        note_latest_report: question.trim() || "No hay pregunta",
      };

      // Simula "Preparando solicitud"
      await new Promise(res => setTimeout(res, 800));
      setProgress(35);

      // Simula "Gestionando archivos"
      if (hasFiles) {
        let response_files = await handleUploadPendingTicketFiles(ticketId, files);
        ticketData.images = response_files;
        await new Promise(res => setTimeout(res, 700));
      } else {
        await new Promise(res => setTimeout(res, 1500)); // espera más si no hay archivos

      }
      setProgress(70);

      await new Promise(res => setTimeout(res, 1500));

      setProgress(85);

      await new Promise(res => setTimeout(res, 1200));

      setProgress(100);




      showAlert({
        msj: "Ticket creado exitosamente",
        status: true,
        notificationSystemRef: notificationSystemRef,
      });


      if (typeof onTicketUpdate === 'function') {
        onTicketUpdate(ticketData); // 👈 esto envía el nuevo ticket al padre
      }
      setTimeout(() => {
        setIsProcessing(false);
        setProgress(0);
        handleClose?.();
      }, 500);

    } catch (error: any) {
      console.error("Error al crear el ticket:", error);
      showAlert({
        msj: error?.response?.data?.errorMessage || "Hubo un error al crear el ticket. Inténtalo nuevamente.",
        status: false,
        notificationSystemRef: notificationSystemRef,
      });
      setIsProcessing(false);
      setProgress(0);
    }
  };




  return (


    <Box p={2}>
      <NOTIFICATION_SYSTEM notificationSystemRef={notificationSystemRef}></NOTIFICATION_SYSTEM>

      {isProcessing ? (
        <TicketProcessingStatus progress={progress} />
      ) : (
        <>


          <Tabs
            value={activeTab}
            onChange={(e, newVal) => setActiveTab(newVal)}
            sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, color: "blue" }}
          >
            <Tab style={{ color: "#434343" }} label="TIPO DE SOLICITUD" />
            <Tab style={{ color: "#434343" }} label="DESCRIPCIÓN DEL CASO" />
          </Tabs>

          {activeTab === 0 && (
            <>
              {modoBusquedaModulo && !module && (
                <Paper
                  variant="outlined"
                  sx={{
                    border: '1px dashed #C7D2FE',
                    backgroundColor: '#F9FAFF',
                    p: 3,
                    borderRadius: 2,
                    mb: 4,
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography fontWeight="bold">1. Seleccionar Módulo</Typography>
                    <Typography fontSize={13} fontWeight={500} color="text.secondary">Paso 1 de 2</Typography>
                  </Box>

                  <TextField
                    fullWidth
                    placeholder="🔍 Buscar módulo..."
                    value={searchModule}
                    onChange={(e) => setSearchModule(e.target.value)}
                    sx={{ mb: 3 }}
                  />

                  <Grid container spacing={2}>
                    {modulos
                      .filter((m) => m.value && m.label.toLowerCase().includes(searchModule.toLowerCase()))
                      .map((m) => (
                        <Grid xs={12} sm={6} md={4} key={m.value}>
                          <Paper
                            onClick={() => {
                              setModule(m.value);
                              let categories: CategoryOption[] = [];

                              switch (m.value) {
                                case 'ACTIVOS': categories = activos_categories; break;
                                case 'BANCOS': categories = bancos_categories; break;
                                case 'COLABORADORES': categories = colaboradores_categories; break;
                                case 'FINANZAS': categories = finanzas_categories; break;
                                case 'INVENTARIOS': categories = inventarios_categories; break;
                                case 'REPORTES': categories = reportes_categories; break;
                                case 'COMPRAS': categories = compras_categories; break;
                                case 'FACTURAS': categories = facturas_categories; break;
                                case 'SOCIO DE NEGOCIOS': categories = snegocios_categories; break;
                                case 'OPERACIONES CON UNILEVER': categories = unilever_categories; break;
                                case 'SOPORTE': categories = soporte; break;
                                case 'ANDROID MÓVIL': categories = android_categories; break;
                                default: categories = [];
                              }

                              setAvailableCategories(categories.filter(c => c.value !== 'Seleccione un valor'));
                            }}
                            elevation={0}
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              backgroundColor: '#F1F5FF',
                              border: '1px solid #E0E7FF',
                              display: 'flex',
                              gap: 2,
                              alignItems: 'center',
                              cursor: 'pointer',
                              '&:hover': {
                                backgroundColor: '#E0ECFF',
                                borderColor: '#2563EB',
                              }
                            }}
                          >
                            <Box
                              sx={{
                                backgroundColor: '#DBEAFE',
                                p: 1,
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 40,
                                height: 40
                              }}
                            >
                              {moduloIcons[m.value]}
                            </Box>
                            <Box>
                              <Typography fontWeight={700} fontSize={14}>{m.label}</Typography>
                              <Typography variant="body2" color="text.secondary">
                                {getModuloSubtitle(m.value)}
                              </Typography>
                            </Box>
                          </Paper>
                        </Grid>
                      ))}
                  </Grid>
                </Paper>
              )}


              {modoBusquedaModulo && module && (
                <Paper
                  variant="outlined"
                  sx={{
                    border: '1px dashed #C7D2FE',
                    backgroundColor: '#F9FAFF',
                    p: 3,
                    borderRadius: 2,
                    mb: 4,
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Button onClick={() => setModule('')} variant="text" sx={{ color: '#2563EB', minWidth: 'auto' }}>
                        <ArrowBackIcon />
                      </Button>
                      <Typography fontWeight="bold">2. Seleccionar Categoría de {module}</Typography>
                    </Box>
                    <Typography fontSize={13} fontWeight={500} color="text.secondary">
                      Paso 2 de 2
                    </Typography>
                  </Box>


                  <TextField
                    fullWidth
                    placeholder="🔍 Buscar categoría..."
                    value={searchCategory}
                    onChange={(e) => setSearchCategory(e.target.value)}
                    sx={{ mb: 3 }}
                  />

                  <Grid container spacing={2}>
                    {availableCategories
                      .filter((c) => c.label.toLowerCase().includes(searchCategory.toLowerCase()))
                      .map((cat) => (
                        <Grid xs={12} sm={6} md={4} key={cat.value}>
                          <Paper
                            onClick={() => {
                              setCategory(cat.value);
                              setModoBusquedaModulo(false);
                            }}
                            elevation={0}
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              backgroundColor: '#F1F5FF',
                              border: category === cat.value ? '2px solid #2563EB' : '1px solid #E0E7FF',
                              cursor: 'pointer',
                              transition: '0.2s ease',
                              '&:hover': {
                                backgroundColor: '#E0ECFF',
                                borderColor: '#2563EB',
                              }
                            }}
                          >
                            <Typography fontWeight={600} fontSize={14}>{cat.label}</Typography>
                          </Paper>
                        </Grid>
                      ))}
                  </Grid>
                </Paper>
              )}


              {!modoBusquedaModulo && (
                <>
                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Seleccione el tipo de solicitud
                  </Typography>
                  <br></br>
                  <Grid container spacing={2}>
                    {reportTypes.map((type) => {
                      const isSelected = reportType === type.value;

                      return (
                        <Grid xs={12} sm={6} key={type.value}>
                          <Paper
                            onClick={() => setReportType(type.value)}
                            elevation={0}
                            sx={{
                              p: 1.5,
                              borderRadius: 2,
                              position: 'relative',
                              cursor: 'pointer',
                              border: isSelected ? '2px solid rgb(146, 203, 236)' : '1px solid #E5E7EB',
                              backgroundColor: isSelected ? '#eaf4ff' : '#FFFFFF',
                              display: 'flex',
                              gap: 2,
                              alignItems: 'flex-start',
                              '&:hover': {
                                borderColor: '#A855F7',
                                backgroundColor: '#eaf4ff',
                              },
                            }}
                          >
                            {/* Icono dentro de fondo */}
                            <Box
                              sx={{
                                width: 36,
                                height: 36,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 1,
                                mt: 0.5,
                                flexShrink: 0,
                              }}
                            >
                              {type.icon}
                            </Box>

                            <Box>
                              <Typography fontWeight="bold">{type.label}</Typography>
                              <Typography variant="body2" color="text.secondary">
                                {type.description}
                              </Typography>
                            </Box>

                            {isSelected && (
                              <Box
                                sx={{
                                  position: 'absolute',
                                  top: 8,
                                  right: 8,
                                  color: '#9333EA',
                                  fontSize: 18,
                                }}
                              >
                                ✔️
                              </Box>
                            )}
                          </Paper>
                        </Grid>
                      );
                    })}
                  </Grid>

                  <Box mt={2}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                      Módulo y Categoría
                    </Typography>

                    {!module ? (
                      <Paper
                        variant="outlined"
                        sx={{
                          border: '2px dashed #D8B4FE',
                          backgroundColor: '#eaf4ff',
                          p: 2.5,
                          borderRadius: 2,
                          textAlign: 'center',
                        }}
                      >


                        <Typography fontWeight={400} sx={{ mb: 3 }}>
                          Elige el módulo del sistema relacionado con tu solicitud para una mejor categorización
                        </Typography>

                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={() => setModoBusquedaModulo(true)}
                          sx={{
                            backgroundColor: '#2563EB',
                            textTransform: 'none',
                            fontWeight: 600,
                            '&:hover': {
                              backgroundColor: '#1D4ED8',
                            }
                          }}
                        >
                          Seleccionar módulo
                        </Button>
                      </Paper>
                    ) : (
                      <Paper
                        variant="outlined"
                        sx={{
                          backgroundColor: '#EEF4FF',
                          border: '1px solid #C7D2FE',
                          borderRadius: 2,
                          p: 2,
                        }}
                      >
                        <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" mb={2}>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Inventory2OutlinedIcon sx={{ color: '#2563EB' }} />
                            <Typography fontWeight={700} color="#1E3A8A">
                              {module}
                            </Typography>
                          </Box>

                          <Box display="flex" gap={1} mt={{ xs: 2, sm: 0 }}>
                            <Button
                              size="small"
                              variant="outlined"
                              startIcon={<EditOutlinedIcon />}
                              onClick={() => {
                                setModule('');
                                setCategory('');
                                setModoBusquedaModulo(true);
                              }}
                              sx={{
                                textTransform: 'none',
                                color: '#4F46E5',
                                borderColor: '#C7D2FE',
                                fontWeight: 600
                              }}
                            >
                              Cambiar módulo
                            </Button>

                            <Button
                              size="small"
                              variant="outlined"
                              startIcon={<EditOutlinedIcon />}
                              onClick={() => setModoBusquedaModulo(true)}
                              sx={{
                                textTransform: 'none',
                                color: '#4F46E5',
                                borderColor: '#C7D2FE',
                                fontWeight: 600
                              }}
                            >
                              Seleccionar categoría
                            </Button>
                          </Box>
                        </Box>

                        <Box sx={{ backgroundColor: '#fff', p: 1.5, borderRadius: 1 }}>
                          <Typography fontSize={14} color="text.secondary">
                            Ruta completa:{' '}
                            <b style={{ color: '#1E3A8A' }}>{module}</b>
                            {category && (
                              <>
                                {' '}→{' '}
                                <b style={{ color: '#3730A3' }}>
                                  {availableCategories.find((c) => c.value === category)?.label || category}
                                </b>
                              </>
                            )}
                          </Typography>
                        </Box>
                      </Paper>
                    )}
                  </Box>


                  <Box mt={2}>
                    <Typography fontWeight={600} mb={1}>Severidad *</Typography>
                    <Grid container spacing={2}>
                      {severities.map((sev) => {
                        const isSelected = severity === sev.label;
                        const bgColor = {
                          Baja: 'rgba(46, 230, 168, 0.1)',
                          Media: 'rgba(249, 178, 51, 0.1)',
                          Alta: 'rgba(245, 5, 69, 0.1)',
                        }[sev.label];

                        return (
                          <Grid xs={12} sm={4} key={sev.label}>

                            <Paper
                              onClick={() => setSeverity(sev.label)}
                              elevation={0}
                              sx={{
                                p: 1.5,
                                borderRadius: 2,
                                border: isSelected ? `2px solid ${sev.color}` : '1px solid #E5E7EB',
                                backgroundColor: isSelected ? bgColor : '#fff',
                                textAlign: 'center',
                                position: 'relative',
                                cursor: 'pointer',
                                transition: '0.2s ease',
                                '&:hover': {
                                  backgroundColor: bgColor,
                                  borderColor: sev.color,
                                }
                              }}
                            >
                              <Typography fontWeight={600}>{sev.label}</Typography>
                              <Box
                                sx={{
                                  height: 6,
                                  width: '60%',
                                  backgroundColor: sev.color,
                                  borderRadius: 4,
                                  mt: 1,
                                  mx: 'auto',
                                }}
                              />
                              {isSelected && (
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                    fontSize: 16,
                                    color: sev.color,
                                  }}
                                >
                                  ✔️
                                </Box>
                              )}
                            </Paper>
                          </Grid>
                        );
                      })}
                    </Grid>

                  </Box>


                  <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
                    <Button variant="outlined" sx={{ color: '#2563EB', borderColor: '#2563EB' }}>SALIR</Button>
                    <Button
                      variant="contained"
                      onClick={() => setActiveTab(1)}
                      sx={{ backgroundColor: '#2563EB' }}
                      disabled={!reportType || !module || !category}
                    >
                      SIGUIENTE
                    </Button>
                  </Box>
                </>
              )}
            </>
          )}

          {activeTab === 1 && (
            <>


              <Box mt={2}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  ¿Ya habías reportado este problema anteriormente?
                </Typography>
                <br></br>
                <Grid container spacing={2}>
                  {questionsUser.map((type) => {
                    const isSelected = hasBeenReported === type.value;

                    return (
                      <Grid xs={12} sm={6} key={type.value + type.label}>
                        <Paper
                          onClick={() => setHasBeenReported(type.value)}
                          elevation={0}
                          sx={{
                            p: 1,
                            borderRadius: 2,
                            position: 'relative',
                            cursor: 'pointer',
                            border: isSelected ? '2px solid  rgb(146, 203, 236)' : '1px solid #E5E7EB',
                            backgroundColor: isSelected ? '#eaf4ff' : '#FFFFFF',
                            display: 'flex',
                            gap: 2,
                            alignItems: 'flex-start',
                            '&:hover': {
                              borderColor: '#eaf4ff',
                              backgroundColor: '#F3E8FF',
                            },
                          }}
                        >
                          {/* Icono dentro de fondo */}
                          <Box
                            sx={{
                              width: 36,
                              height: 36,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: 2,
                              mt: 0.5,
                              flexShrink: 0,
                            }}
                          >
                            {type.icon}
                          </Box>

                          <Box>
                            <Typography fontWeight="bold">{type.label}</Typography>
                            <Typography variant="body2" color="text.secondary">
                              {type.description}
                            </Typography>
                          </Box>

                          {isSelected && (
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                color: '#9333EA',
                                fontSize: 18,
                              }}
                            >
                              ✔️
                            </Box>
                          )}
                        </Paper>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>


              <Box mt={2}>
                <Typography fontWeight={600} gutterBottom>
                  Asunto *
                </Typography>
                <TextField
                  fullWidth
                  placeholder={'Describe brevemente el problema'}
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  inputProps={{ maxLength: 100 }}
                  helperText={`${subject.length}/100`}
                  FormHelperTextProps={{
                    sx: {
                      textAlign: 'right',
                      marginRight: 0,
                      color: '#6B7280',
                      fontSize: '12px'
                    }
                  }}
                />
              </Box>
              {hasBeenReported === true && (
                <Box mt={1}>
                  <Typography fontWeight={600} gutterBottom>
                    ¿Cuándo reportaste este problema por última vez? (Opcional)
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder={'Ingresa una fecha aproximada, por ejemplo: "el dia jueves", "hace una semana", "hace un mes"...'}
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                    inputProps={{ maxLength: 100 }}
                    helperText={`${question.length}/100`}
                    FormHelperTextProps={{
                      sx: {
                        textAlign: 'right',
                        marginRight: 0,
                        color: '#6B7280',
                        fontSize: '12px'
                      }
                    }}
                  />
                </Box>
              )}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography fontWeight={600}>Descripción *</Typography>
                <Box display="flex" gap={1}>
                  <Button
                    component="label"
                    variant="outlined"
                    startIcon={<UploadFile />}
                    sx={{ color: '#2563EB', borderColor: '#2563EB', textTransform: 'none' }}
                  >
                    Adjuntar
                    <input
                      type="file"
                      accept=".pdf,.txt,.csv,.tsv,.zip,.rar,.doc,.docx,.xls,.xlsx,.odt,.ods,.xml,.jpg,.jpeg,.png,.mp3,.wav,.ogg,.oga,.flac,.aac,.m4a,.wma,.amr,.opus"
                      hidden
                      multiple
                      onChange={handleFileChange}
                    />
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<Mic />}
                    onClick={handleAudioRecording}
                    sx={{ color: '#2563EB', borderColor: '#2563EB', textTransform: 'none' }}
                  >
                    {isRecording ? 'Detener' : 'Grabar'}
                  </Button>
                </Box>
              </Box>

              {!isRecording ? (
                <TextField
                  fullWidth
                  required
                  placeholder={
                    hasBeenReported === true
                      ? 'Indica qué ha cambiado desde el último reporte o si el problema continúa igual.'
                      : 'Describe detalladamente el problema que estás experimentando.'
                  }
                  multiline
                  minRows={5}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: 2,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                    }
                  }}
                />
              ) : (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                  height="120px"
                  sx={{
                    bgcolor: '#FFF5F5',
                    border: '2px dashed #EF4444',
                    borderRadius: 2,
                    p: 2,
                    textAlign: 'center',
                  }}
                >
                  <Typography fontWeight={600} color="#EF4444">🎙️ Grabando audio...</Typography>
                  <Typography variant="caption" color="#EF4444" mb={1}>
                    Tiempo: {Math.floor(recordingTime / 60)}:{(recordingTime % 60).toString().padStart(2, '0')}
                  </Typography>

                  <Box display="flex" gap={0.5}>
                    {[0, 0.2, 0.4, 0.6, 0.8].map((delay, i) => (
                      <Box
                        key={i}
                        sx={{
                          width: 4,
                          height: 20,
                          borderRadius: 1,
                          backgroundColor: '#EF4444',
                          animation: 'wave 1s infinite',
                          animationDelay: `${delay}s`,
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}


              {files.length > 0 && (
                <Box mt={2} sx={{
                  maxHeight: '300px',
                  overflow: 'auto',
                }}>
                  <Typography variant="subtitle1" fontWeight={600} mb={1}>Archivos seleccionados:</Typography>

                  {files.map((file, index) => {
                    const isAudio = file.type.startsWith("audio/");
                    const isImage = file.type.startsWith("image/");
                    const isPDF = file.type === "application/pdf";
                    const isPreviewable = isImage || isPDF;

                    const sizeInKB = file.size / 1024;
                    const readableSize = sizeInKB > 1024
                      ? `${(sizeInKB / 1024).toFixed(1)} MB`
                      : `${sizeInKB.toFixed(1)} KB`;

                    return (
                      <Box
                        key={index}
                        display="flex"
                        flexDirection="column"
                        sx={{
                          backgroundColor: "#F3F4F6",
                          px: 2,
                          py: 1,
                          borderRadius: 2,
                          mb: 1,
                        }}
                      >
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                          <Box display="flex" alignItems="center" gap={1} width="70%">
                            {getFileIcon(file)}
                            <Box>
                              <Typography fontSize={14} noWrap maxWidth="100%">
                                {file.name}
                              </Typography>
                            </Box>
                          </Box>

                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="caption" color="text.secondary" sx={{ minWidth: 60 }}>
                              {readableSize}
                            </Typography>

                            <Box sx={{ width: 36, display: 'flex', justifyContent: 'center' }}>
                              {isPreviewable ? (
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    setPreviewFile({
                                      url: URL.createObjectURL(file),
                                      type: file.type,
                                    })
                                  }
                                >
                                  <VisibilityIcon fontSize="small" />
                                </IconButton>
                              ) : (
                                <Box sx={{ width: 24 }} />
                              )}
                            </Box>

                            <IconButton size="small" onClick={() => handleRemoveFile(index)}>
                              <DeleteIcon fontSize="small" sx={{ color: "#EF4444" }} />
                            </IconButton>
                          </Box>
                        </Box>

                        {isAudio && (
                          <Box mt={1}>

                            <audio
                              controls
                              src={URL.createObjectURL(file)}
                              style={{ width: "100%", marginTop: 4, height: 28 }}
                            />
                          </Box>
                        )}
                      </Box>
                    );
                  })}


                </Box>
              )}

              {previewFile && (
                <Box
                  position="fixed"
                  top="50%"
                  left="50%"
                  zIndex={9999}
                  sx={{
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'white',
                    boxShadow: 24,
                    p: 2,
                    borderRadius: 2,
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                  }}
                >
                  {previewFile.type.startsWith("image/") ? (
                    <img
                      src={previewFile.url}
                      alt="Vista previa"
                      style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: 8 }}
                    />
                  ) : (
                    <iframe
                      src={previewFile.url}
                      title="Vista previa PDF"
                      style={{ width: '80vw', height: '80vh', border: 'none' }}
                    />
                  )}

                  <Box textAlign="center" mt={2}>
                    <Button variant="outlined" onClick={() => setPreviewFile(null)} color="secondary">
                      Cerrar
                    </Button>
                  </Box>
                </Box>
              )}


              <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
                <Button variant="outlined" onClick={() => setActiveTab(0)} sx={{ color: '#2563EB', borderColor: '#2563EB' }}>REGRESAR</Button>
                <Button variant="contained" sx={{ backgroundColor: '#2563EB' }} onClick={handleCreateTicket}>LEVANTAR TICKET</Button>
              </Box>
            </>
          )}
        </>
      )}

    </Box>


  );
};

export default TicketForm;
